<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('customerProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('customerProfile.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-end">
          <ts-input
            v-model="search"
            :placeholder="$t('customerProfile.search')"
            style="width: 250px"
            class="ml-2 inline-block"
          />
        </div>
      </ts-card-wrapper>
      <div id="list" class="ts-overflow-scroll">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">{{ record.customer_name }}</td>
            <td class="ts-whitespace-no-wrap text-center">{{ record.phone_number }}</td>
            <td class="ts-whitespace-no-wrap text-center">{{ record.year_of_born }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.locations }}</td>
            <td class="ts-whitespace-no-wrap text-right">{{ record.balance | format_number }}</td>
            <td class="ts-whitespace-no-wrap text-center">{{ record.registered_date }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              <a-switch
                size="small"
                :checked="record.is_active"
                :loading="record._deleting"
                @change="changeStatus(record)"
              />
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'

export default {
  name: 'customerProfileList',
  data() {
    return {
      loading: false
    }
  },
  filters: {
    format_number(value) {
      return `${value.toLocaleString()}`
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administrator/customerProfile', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.administrator.customerProfile.search
      },
      set(newValue) {
        this.$store.commit('administrator/customerProfile/SET_SEARCH', newValue)
        this.$store.commit('administrator/customerProfile/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('customerProfile.name') },
        {
          name: this.$t('customerProfile.phoneNumber'),
          style: 'text-align: center'
        },
        {
          name: this.$t('customerProfile.yearOfBorn'),
          style: 'text-align: center'
        },
        {
          name: this.$t('customerProfile.location')
        },
        {
          name: this.$t('customerProfile.balance'),
          style: 'text-align: right'
        },
        {
          name: this.$t('customerProfile.registeredDate'),
          style: 'text-align: center'
        },
        {
          name: this.$t('customerProfile.active'),
          style: 'text-align: center'
        }
      ]
    }
  },
  methods: {
    ...mapActions('administrator/customerProfile', ['status']),
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administrator/customerProfile/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    changeStatus(record) {
      record._deleting = true
      this.status({
        id: record.customer_id,
        data: {
          is_active: record.is_active
        }
      })
        .then(response => {
          this.$toasted.success(response.message)
          record.is_active = !record.is_active
        })
        .catch(error => {
          record.is_active = record.is_active
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('administrator/customerProfile/RESET_STATE')
    next()
  }
}
</script>